'use strict';

var angular = require('angular');
var dependencies = ['AVRO.System.SystemConstants', 'AVRO.SystemStatus.Reoptimization'];
module.exports = angular.module('AVRO.SystemStatus.Panel', dependencies).config(require('./config/SystemStatusPanelConfig')).controller('SystemStatusPanelController', require('./controllers/SystemStatusPanelController')).controller('SystemStatusToolbarController', require('./controllers/SystemStatusToolbarController'));